(function ($) {
  "use strict";
if (document.querySelector('#zineProduct')){

  const $productGallery = $(document).find('.woocommerce-product-gallery');
  const variationsString= document.querySelector('form.variations_form')?.dataset.product_variations
  const variations = variationsString ?JSON.parse( variationsString ) : {};
   document.querySelector('.quantity').after(document.querySelector('.ppc-button-wrapper'))
  if ($productGallery.length) {

    const $figure = $productGallery.find('figure');

    $figure.wrap( "<div class='zineProduct_viewport'></div>" );

    const figureClone = $figure.clone();
    // const figureCloneWrap = figureClone.wrap( "<div class='zineProduct_slider'></div>");

    figureClone.find('.woocommerce-product-gallery__image').each((i,element) => {
      element.classList.remove('woocommerce-product-gallery__image');
    });

    const $figureCloneWrap = $('<div>', {
      class:'zineProduct_slider'
    }).append(figureClone);

    $figureCloneWrap.append($('<span>', {
      class:'zineControl zineControl-prev js_zinePrev'
    }));
    $figureCloneWrap.append($('<span>', {
      class:'zineControl js_zineNext'
    }));


    const $buttonHTML = $('<span>', {
      class:'zineProduct_previewBtn',
      role:'button',
      html: 'Preview'
    });

    $productGallery.append($buttonHTML);

    $productGallery.append($figureCloneWrap);


    const $sliderFigure = $(document).find('.zineProduct_slider figure');

    if ($sliderFigure.length) {
      tns({
        container: $sliderFigure[0],
        items: 3,
        speed: 400,
        nav: false,
        responsive: {
          576: {
            items: 4
          },
          768: {
            items: 5
          },
        },
        arrowKeys: true
      });
    }
  }


  $(document).on('click', '.woocommerce-product-gallery__wrapper a', function(e) {
    e.preventDefault();
  });

  /* Trigger Click */
  $(document).on('click', '.js_zinePrev', function(e) {
    e.preventDefault();

    const $prevControl = $(this).parents('.zineProduct_slider').find('[data-controls="prev"]');

    if ($prevControl.length) {
      $prevControl.click();
    }
  });

  /* Trigger Click */
  $(document).on('click', '.js_zineNext', function(e) {
    e.preventDefault();

    const $nextControl = $(this).parents('.zineProduct_slider').find('[data-controls="next"]');

    if ($nextControl.length) {
      $nextControl.click();
    }
  });

  /* Trigger Preview Click */
  $(document).on('click', '.zineProduct_previewBtn', function(e) {
    e.preventDefault();

    const $galleryImage = $(this).parents('.zineProduct_gallery').find('.woocommerce-product-gallery__image:visible img');
    $galleryImage.trigger('click');
  });


  $(document).on('click', '.zineProduct_slider .tns-item', function(e) {
    const dataThumb = $(this).attr('data-thumb');

    if (dataThumb) {
      // $("ul").find(`[data-slide='${current}']`)

      const $productViewport = $(document).find('.zineProduct_viewport');

      const height = $productViewport.height();
      $productViewport.height(height);

      const $el = $productViewport.find(`div[data-thumb='${dataThumb}']`);

      if ($el.length && $el.is(':hidden')) {
        $productViewport.find('.woocommerce-product-gallery__image:visible').slideUp(300);
        $el.slideDown(300);

        // $productViewport.height($el.height());

        $productViewport.animate({
          height: $el.height()
        }, 300, function() {
          // Animation complete.
        });
      }

      if ($el.height() < height) {
        $('#zineProduct')[0].scrollIntoView();
      }
    }

  });


  /* Hacky work around. How to hook on flexslider init callback? */
  setTimeout(() => {
    let $zineControls = document.querySelectorAll('.zineControl____TODO');

    if ($zineControls.length) {
      const $flexControlNav = document.querySelector('.flex-control-nav');
      const clientHeight = $flexControlNav.clientHeight;

      /* Add new button */
      if ($flexControlNav) {
        const buttonHTML = '<span class="galleryBtn" role="button">Preview</span>';

        $flexControlNav.insertAdjacentHTML('afterbegin', buttonHTML);
        const button = document.querySelector('.galleryBtn');
        button.style.opacity = 1;

        $(button).on('click', function(e) {
          e.preventDefault();

          const $res = $(this).parents('#zineProduct').find('.flex-active-slide img');
          $res.trigger('click');
        })
      }

      /* Set Controls height. Set visible */
      $zineControls.forEach((element) => {
        if ($flexControlNav) {
          element.style.height = (clientHeight - 10) + 'px';
          element.style.opacity = 1;
        }
      });

    }
  }, 500);


  /*** Custom Variations Select ***/
  const $variationsSelect = $('.zineProduct table.variations select');

  /* Init custom variation input. Wrap default Select with button representation */
  if ($variationsSelect.length) {
    $variationsSelect.each((index, select) => {
      const $variationSelect = $('<div>', {
        class:'variationSelect js_variationSelect'
      });

      $variationSelect.append($('<div>', {
        class:'variationSelect_wrap'
      }));

      const $variationSelectOptions = $('<div>', {
        class:'variationSelect_options'
      });

      $(select).find('option').each((i, option) => {
        console.log(option)
        if (option.value) {
          let className = variations[i-1].availability_html.length>0 ? '' : 'optionActive';

          if(className==='optionActive' && i===1){
            className ='optionActive optionSelected'
          }
          console.log(className)
          const finalClassName = className==='optionActive' ? '' : 'optionActive';
          $variationSelectOptions.append(`<span class="${className}" role="button" data-value="${option.value}">${option.value}</span>`);
        }

      });


      $variationSelect.append($variationSelectOptions);
      /* TODO: Remove random class */
      // $variationSelect.append(`<small class="text-muted">(ToDO: Remove random availability)</small>`);
      $(select).wrap($variationSelect);
    });

  }

  /* Set variation Selection */
  $(document).on('click', '.js_variationSelect', function(e) {
    if (e.target.classList.contains('optionActive')) {
      const $variationSelect = $(this);
      const $option = $(e.target);

      const value = $option.attr('data-value');

      if (value !== undefined) {
        const $select = $variationSelect.find('select');

        $select.val(value).trigger('change');

        $variationSelect.find('.optionSelected').removeClass('optionSelected');
        $option.addClass('optionSelected');
      }
    }
  });

  /* Clear selection */
  $(document).on('click', '#zineProduct .reset_variations', function(e) {
    const $optionSelected = $(this).parents('td').find('.optionSelected');

    if ($optionSelected.length) {
       $optionSelected.removeClass('optionSelected');
    }

    // CLear quantity input
    $('#zineProduct input.qty').val(1);
  })

}
})(jQuery);